import { $ } from '@utils';

function init() {
  if (!$('[data-au-checkbox-group]')) return;
  // helper function to create nodeArrays (not collections)
  const nodeArray = (selector, parent = document) => [].slice.call(parent.querySelectorAll(selector));

  // checkboxes of interest
  const allThings = nodeArray('[data-au-checkbox-group] [data-au-checkbox] input');

  // global listener
  addEventListener('change', (e) => {
    let check = e.target;

    // exit if change event did not come from
    // our list of allThings
    if (allThings.indexOf(check) === -1) return;

    // check/uncheck children (includes check itself)
    const children = nodeArray('[data-au-checkbox-group] [data-au-checkbox] input', check.parentNode);
    children.forEach((child) => (child.checked = check.checked));

    // traverse up from target check
    while (check) {
      // find parent and sibling checkboxes (quick'n'dirty)
      const parent = check.closest('[data-au-checkbox-group]').parentNode.querySelector('[data-au-checkbox] input');
      if (parent.closest('[data-au-checkbox]').querySelector('[data-au-checkbox-group]') === null) return;

      const siblings = nodeArray(
        '[data-au-checkbox] input',
        parent.closest('[data-au-checkbox]').querySelector('[data-au-checkbox-group]'),
      );

      // get checked state of siblings
      // are every or some siblings checked (using Boolean as test function)
      const checkStatus = siblings.map((check) => check.checked);
      const every = checkStatus.every(Boolean);
      const some = checkStatus.some(Boolean);

      // check parent if all siblings are checked
      // set indeterminate if not all and not none are checked
      parent.checked = every;
      parent.indeterminate = !every && every !== some;

      // prepare for next loop
      check = check !== parent ? parent : null;
    }
  });
}

export default { init };
